//#region Libraries
import styled from "styled-components";
//#endregion

export const HeaderDate = styled.h4`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    margin: 0;
    font-size: 13px;
    text-align: center;
    & span {
        max-width: 150px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    &.today {
        gap: 5px;
        color: var(--purple-2);
        & div {
            display: grid;
            place-items: center;
            width: 25px;
            border-radius: 50%;
            height: 25px;
            background-color: var(--purple-2);
            color: var(--light-1);
        }
    }
`;